var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.params.reports),function(report){return _c(report,{key:report,tag:"component",attrs:{"is-printing":true,"dataQuery":_vm.dataQuery}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }